import { cn } from "@/lib/utils";

/**
 * Gandara brand lockup: botanical mark (stem, leaves, hanging acorn) +
 * "Gandara / INTERNATIONAL SCHOOL" wordmark. Paths transcribed 1:1 from
 * GandaraMarkPainter in gandara-app/apps/admin_web brand_identity.dart.
 * tone="dark" for light backgrounds (header on paper);
 * tone="light" for dark backgrounds (footer on green).
 */
interface GandaraLogoProps {
  tone?: "dark" | "light";
  className?: string;
}

const GandaraLogo = ({ tone = "dark", className }: GandaraLogoProps) => {
  const light = tone === "light";
  const stem = light ? "#F7F3EA" : "#2D2720";
  const leaf = light ? "#C9B37A" : "#3F6B4E";
  const acornBody = "#C9B37A";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-3 text-left",
        light ? "text-primary-foreground" : "text-foreground",
        className,
      )}
    >
      <svg viewBox="0 0 95 170" className="h-[52px] w-auto flex-none" aria-hidden="true">
        {/* stem */}
        <path
          d="M55 158 C52 128 58 100 54 74 C50 54 58 34 54 14"
          stroke={stem}
          strokeWidth="1.2"
          strokeLinecap="round"
          fill="none"
        />
        {/* stem tip */}
        <path d="M54 14 C51 10 52 5 55 4 C58 5 57 10 54 14 Z" fill={stem} />
        {/* top-right leaf */}
        <path
          d="M54 34 C62 28 72 30 78 24 C82 28 80 34 76 36 C84 36 88 42 86 46 C80 48 74 44 72 46 C76 50 76 56 72 58 C66 54 62 48 60 42 C58 40 56 38 54 34 Z"
          fill={leaf}
        />
        {/* left leaf */}
        <path
          d="M54 74 C44 68 32 70 26 62 C22 66 24 72 28 74 C18 76 12 84 14 90 C22 92 28 86 32 88 C24 94 22 102 26 106 C34 104 40 96 44 92 C40 98 42 104 46 106 C52 100 54 90 54 74 Z"
          fill={leaf}
        />
        {/* acorn cap */}
        <path d="M70 118 C68 114 74 110 82 110 C90 110 94 114 92 118 Z" fill={stem} />
        {/* acorn body */}
        <path d="M70 118 C70 128 76 138 82 138 C88 138 92 128 92 118 Z" fill={acornBody} />
        {/* bottom-left leaf */}
        <path
          d="M54 138 C46 136 36 138 30 144 C34 148 40 146 42 148 C36 152 34 158 38 160 C46 158 52 150 54 138 Z"
          fill={leaf}
        />
      </svg>
      <span>
        <span className="block font-sans text-[26px] leading-none font-medium">
          Gán<em className="font-serif font-normal">d</em>ara
        </span>
        <span
          className={cn(
            "mt-1.5 block font-mono text-[10px] leading-none tracking-[2px]",
            light ? "text-primary-foreground/80" : "text-[#8A7F6D]",
          )}
        >
          INTERNATIONAL SCHOOL
        </span>
      </span>
    </span>
  );
};

export default GandaraLogo;
